import React, { useEffect, useState } from 'react'
import ListElement from '../../components/others/listelement'
import MyLoader from '../../components/others/loader'
import Subtitle from '../../components/others/subtitle'
import Post from '../../config/post.request'
import { IPosts } from '../../config/types'

export default function Articles() {

    const [ data, setData ] = useState<IPosts[]>([])
    const [ loading, setLoading ] = useState(true);

    useEffect(() => {
        document.title = "New Wave | ARTICLES"
        const getPosts = async () => {
            const postsData = await Post.getAllPosts("articles");
            
            setLoading(false);
            if (!postsData) return;
            return setData(postsData)
        }
        getPosts();
    },[])

    return (
        <main className="articles-container">
            <Subtitle subtitle="NOS ARTICLES" />
            <section>
                {
                    loading ? <MyLoader />:
                    data.map(e => {
                        return <ListElement key={e.uuid} data={e} type={e.post_type} />
                    })
                }
            </section>
        </main>
    )
}
